import { instance } from '7-shared/api';
import { INews } from '../api/types';

export const newsApi = {
  getCurrentNews(id: number): Promise<INews> {
    return instance.get(`cms/news/${id}`).then((res) => res.data);
  },
};
